module.exports = __webpack_public_path__ + "static/media/speech-bubble.3665bb25.png";